/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ConversationsDeleteRequest = {
  conversationId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ConversationsDeleteRequest$inboundSchema: z.ZodType<
  ConversationsDeleteRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  conversation_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "conversation_id": "conversationId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ConversationsDeleteRequest$Outbound = {
  conversation_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ConversationsDeleteRequest$outboundSchema: z.ZodType<
  ConversationsDeleteRequest$Outbound,
  z.ZodTypeDef,
  ConversationsDeleteRequest
> = z.object({
  conversationId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    conversationId: "conversation_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function conversationsDeleteRequestToJSON(
  conversationsDeleteRequest: ConversationsDeleteRequest,
): string {
  return JSON.stringify(
    ConversationsDeleteRequest$outboundSchema.parse(conversationsDeleteRequest),
  );
}
export function conversationsDeleteRequestFromJSON(
  jsonString: string,
): SafeParseResult<ConversationsDeleteRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConversationsDeleteRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConversationsDeleteRequest' from JSON`,
  );
}
